import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import EditIcon from '@mui/icons-material/EditOutlined';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOnIcon from '@mui/icons-material/VisibilityOutlined';
import { Box, Button } from '@mui/material';
import { push } from 'connected-react-router';
import queryString from 'query-string';

import { selectOutOfStockMenuItemIds } from 'rdx/menu';
import { selectQuery } from 'rdx/router';

const MenuControls: React.FC<Record<string, any>> = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const query = useSelector(selectQuery);
  const shouldShowSoldOutItems = query.showSoldOutItems === 'true';
  const outOfStockItemIds = useSelector(selectOutOfStockMenuItemIds);

  const handleShowSoldOutChange = useCallback(() => {
    dispatch(
      push({
        search: queryString.stringify({ ...query, showSoldOutItems: !shouldShowSoldOutItems }),
      }),
    );
  }, [dispatch, query, shouldShowSoldOutItems]);

  const handleEdit = useCallback(() => {
    dispatch(
      push({
        search: queryString.stringify({ ...query, mode: 'edit' }),
      }),
    );
  }, [dispatch, query]);

  return (
    <Box display="flex" alignItems="center">
      <Box mr={2}>
        <Button
          variant="contained"
          color="secondary"
          startIcon={shouldShowSoldOutItems ? <VisibilityOnIcon /> : <VisibilityOffIcon />}
          onClick={handleShowSoldOutChange}
        >
          {intl.formatMessage(
            {
              id: shouldShowSoldOutItems
                ? 'widgets.MenuEditor.hideSoldOutItems'
                : 'widgets.MenuEditor.showSoldOutItems',
            },
            { value: outOfStockItemIds.length },
          )}
        </Button>
      </Box>
      <Box>
        <Button variant="contained" startIcon={<EditIcon />} onClick={handleEdit}>
          {intl.formatMessage({ id: 'widgets.MenuEditor.edit' })}
        </Button>
      </Box>
    </Box>
  );
};

export default MenuControls;
